import { Alert, IconButton, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'
import { ReactComponent as X } from '../../../assets/icons/x.svg'

const NewManualAlertView = ({ onClose }) => {
  const t = useTranslations()

  const openUserManualPdf = async () => {
    const document = await fetch(
      process.env.PUBLIC_URL + '/documents/Manual usuario CTT Express.pdf',
    )
    const blob = await document.blob()
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank')
  }

  return (
    <Alert
      severity="warning"
      icon={false}
      sx={{ ...styles.alert, ...styles.alertWarning }}
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={() => {
            onClose()
            localStorage.setItem(
              'userManualDate',
              process.env.REACT_APP_SHOW_MANUAL_ALERT,
            )
          }}
        >
          <X />
        </IconButton>
      }
    >
      <Typography component="p" variant="body2">
        {t('help:new-user-manual-alert', {
          link: text => (
            <span style={{ cursor: 'pointer' }} onClick={openUserManualPdf}>
              <u>
                <strong>{text}</strong>
              </u>
            </span>
          ),
        })}
      </Typography>
    </Alert>
  )
}

export default NewManualAlertView
